$(document).on("click","#buy-now-home-page" ,function(){

                var get_id_this = $(this).attr('product_id');

            console.log(get_id_this);
              $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {
              quantity:1,
              id: get_id_this
              },
              dataType: 'json',
              success: function() {
              window.location.href = "/checkout";
                }
              });
                });
/*<script type="text/javascript">// <![CDATA[
	document.querySelector('.slide-button.button.banner-button-animated').addEventListener('click', function (){
		window._klOnsite = window._klOnsite || []; 
		window._klOnsite.push(['openForm', 'FORM_ID']);
	});
</script>*/
